<template>

    <v-container fill-height fluid>

        <v-row justify="center" align="center" v-if="show" class="pb-6">
            <v-col>
                <div :class="($vuetify.breakpoint.smAndUp) ? 'login-form-wrapper' : ''">
                    <router-view></router-view>
                </div>
            </v-col>
        </v-row>

        <ProfileFooter/>

    </v-container>

</template>

<script>

import ProfileFooter from '../components/Login/ProfileFooter.vue';

export default {
  name: 'GlobalLoginLayout',
  data() {
    return {
      show: false,
    };
  },
  components: {
    ProfileFooter,
  },
  methods: {},
  computed: {},
  async created() {

  },
  updated() {
  },
  mounted() {
    this.show = true; // might need this.$nextTick
  },
};
</script>

<style scoped>
    .login-form-wrapper {
        max-width: 30rem !important;
        border-radius: 3px;
        border: 1px solid var(--v-form-border-base);
        border-width: 1px 2px 2px 1px; /* shadow effect on container */
        padding: 3rem;
        margin: 0 auto; /* horizontally centre the div inside the parent container */
    }

    .login-logo {
        max-width: 424px !important;
    }
</style>
